import React from 'react';
import { ProjectHistoryHeader } from './ProjectHistoryHeader';
import { ProjectHistoryList } from './ProjectHistoryList';
import { ProjectHistorySidebar } from './ProjectHistorySidebar';
import { useProjectHistory } from '../hooks/useProjectHistory';

export function ProjectHistoryMain() {
  const { data, isLoading } = useProjectHistory();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải lịch sử thay đổi...</div>;
  }

  return (
    <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
      {/* Main Content */}
      <div className="xl:col-span-9 space-y-6">
        <div className="flex items-center justify-between">
           <h3 className="text-sm font-normal text-slate-900 tracking-wider">Lịch sử thay đổi</h3>
        </div>
        <ProjectHistoryHeader />
        <ProjectHistoryList history={data.history} />
      </div>

      {/* Sidebar */}
      <div className="xl:col-span-3">
        <ProjectHistorySidebar data={data} />
      </div>
    </div>
  );
}
